import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Router, Switch } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import ErrorBoundary from './components/ErrorBoundary';

import Analytics from './helpers/analytics/analytics';
import CompaniesContainer from './containers/CompaniesContainer';
import ManagerDashboard from './containers/ManagerDashboard';
import Directory from './containers/Directory';
import ErrorPage from './containers/ErrorPage';
import ForgotPassword from './containers/ForgotPassword';
import GlobalBanner from './containers/GlobalBanner/index';
import GlobalModal from './containers/GlobalModal';
import CircleGlobalModal from './containers/CircleGlobalModal';
import HttpsRedirect from 'react-https-redirect';
import InfoErrorSlider from './components/InfoErrorSlider';
import PORContainer from './containers/PORContainer';
import LocationCRUD from './containers/PORContainer/LocationCRUD';
import PORProjectDocuments from './containers/PORContainer/PORProjectDocuments';
import PORLocationDocuments from './containers/PORContainer/PORLocationDocuments';
import logErrorForCloudWatch from './helpers/awsCloudwatchLogs';
import Login from './containers/Login';
import MobileSpinner from './components/MobileSpinner';
import MobileEntryWrapper from './mobileWrappers/MobileEntryWrapper/index';
import NotificationsWrapper from './mobileWrappers/NotificationsWrapper';
import ProjectsContainer from './containers/ProjectsContainer';
import ProjectSummaryContainer from './containers/ProjectSummaryContainer';
import ProjectHierarchy from './containers/ProjectsContainer/ProjectHierarchy';
import ProjectCRUD from './containers/ProjectsContainer/ProjectCRUD';
import CreateNewProject from './containers/ProjectsContainer/ProjectCRUD/CreateNewProject';
import TaskCRUD from './components/TaskCRUD';
import ProjectsContainerTasks from './containers/ProjectsContainer/ProjectsContainerTasks';
import ProjectsTasksWrapper from './mobileWrappers/ProjectsTasksWrapper';
import ProjectsListWrapper from './mobileWrappers/ProjectsListWrapper';
import ReferenceDocumentsLibrary from './containers/ReferenceDocumentsLibrary';
import RouteNotFound from './components/RouteNotFound';
import SetPassword from './containers/SetPassword';
import DashBoardWrapper from './mobileWrappers/DashBoardWrapper';
import ProjectDetailsWrapper from './mobileWrappers/ProjectDetailsWrapper';
import DelayCreateWrapper from './mobileWrappers/DelayCreateWrapper';
import DelayViewWrapper from './mobileWrappers/DelayViewWrapper';
import DelayTypesContainer from './containers/DelayTypesContainer';
import DelayReportContainer from './containers/DelayReportContainer';
import TasksContainer from './containers/TasksContainer';
import TaskDetailWrapper from './mobileWrappers/TaskDetailWrapper';
import TaskDetailDirectWrapper from './mobileWrappers/TaskDetailDirectWrapper';
import TaskCompletionStepDetailWrapper from './mobileWrappers/TaskCompletionStepDetailWrapper';
import InventoryEditWrapper from './mobileWrappers/InventoryEditWrapper';
import UserProfile from './containers/UserProfile';
import UserSettingsWrapper from './mobileWrappers/UserSettingsWrapper';
import SwitchCompanyWrapper from './mobileWrappers/SwitchCompanyWrapper';
import UserProfileWrapper from './mobileWrappers/UserProfileWrapper';
import MoreMenuWrapper from './mobileWrappers/MoreMenuWrapper';
import MapsWrapper from './mobileWrappers/MapsWrapper';
import DirectoryWrapper from './mobileWrappers/DirectoryWrapper';

import OurHistory from './helpers/OurHistory/OurHistory';
import MobilePhotoDisplay from './components/TaskCompletionStepsMobile/MobilePhotoDisplay';
import ProjectTypesContainer from './containers/ProjectTypesContainer';
import ProjectTemplateHierarchy from './containers/ProjectTemplatesContainer/ProjectTemplateHierarchy';
import ProjectTemplateTasks from './containers/ProjectTemplatesContainer/ProjectTemplateTasks';
//import MobileBadConnectionAlert from './components/banners/MobileBadConnectionAlert';

import TimeoutPopup from './components/TimeoutPopup';
import ReloginPopup from './components/ReloginPopup';
import SupportForm from './components/SupportForm/';
import DisableAppBackground from './components/DisableAppBackground';

import './settings/configurationSettings.js';
import './App.scss';
import dataModel from './models/DataModel';
import CacheUtil from './helpers/session/CacheUtil';
import ConnectivityHeartbeat from './helpers/ConnectivityHeartbeat';
import MobileSupportWrapper from './mobileWrappers/MobileSupportWrapper';
import i18n from './i18n';
import { MakeRoutesWithSubRoutes } from './MakeRoutesWithSubRoutes';
import InsightsRouteGuard from './components/InsightsRouteGuard';

const appRoutes = [
  /** WEB ROUTES */
  // { path: "/", component: ProjectsContainer },
  { path: '/error-page', component: ErrorPage },
  { path: '/login', component: Login },
  {
    path: '/projects', component: ProjectsContainer, routes: [
      { path: '/projects/summary', component: ProjectSummaryContainer },
      { path: '/projects/closeouts', component: ProjectSummaryContainer },
      { path: '/projects/groups', component: ProjectSummaryContainer },
      { path: '/projects/:project_id/bulk-assign/build/:build_id/', component: ProjectsContainerTasks },
      { path: '/projects/:project_id/bulk-assign', component: ProjectHierarchy },
      { path: '/projects/:project_id/build/:build_id/task/:task_id/edit', component: TaskCRUD },
      { path: '/projects/:project_id/build/:build_id/task/:task_id', component: TaskCRUD },
      { path: '/projects/:project_id/build/:build_id', component: ProjectsContainerTasks },
      { path: '/projects/:project_id/edit', component: ProjectCRUD },
      { path: '/projects/create', component: CreateNewProject },
      { path: '/projects/:project_id', component: ProjectHierarchy },
    ],
  },
  {
    path: '/project-types/:project_type_id', component: ProjectTypesContainer, routes: [
      { path: '/project-types/:project_type_id/project-template/:project_template_id/build/:build_id/task/:task_id/edit', component: TaskCRUD },
      { path: '/project-types/:project_type_id/project-template/:project_template_id/build/:build_id/task/:task_id', component: TaskCRUD },
      { path: '/project-types/:project_type_id/project-template/:project_template_id/build/:build_id', component: ProjectTemplateTasks },
      { path: '/project-types/:project_type_id/project-template/:project_template_id', component: ProjectTemplateHierarchy },
    ],
  },
  {
    path: '/project-types', component: ProjectTypesContainer, routes: [
      { path: '/project-types/:project_type_id/project-template/:project_template_id/build/:build_id/task/:task_id/edit', component: TaskCRUD },
      { path: '/project-types/:project_type_id/project-template/:project_template_id/build/:build_id/task/:task_id', component: TaskCRUD },
      { path: '/project-types/:project_type_id/project-template/:project_template_id/build/:build_id', component: ProjectTemplateTasks },
      { path: '/project-types/:project_type_id/project-template/:project_template_id', component: ProjectTemplateHierarchy },
    ],
  },

  { path: '/directory', component: Directory },
  { path: ['/manager-dashboard/dashboard', '/manager-dashboard/project-reporting', '/manager-dashboard/activity-log'], component: ManagerDashboard },

  { path: '/tasks/project/:project_id/task/:task_id', component: TasksContainer },
  { path: '/tasks/project/:project_id', component: TasksContainer },
  { path: '/tasks/project', component: TasksContainer },
  
  { path: '/companies/:company_id/vendor/:vendor_id/:action', component: CompaniesContainer },
  { path: '/companies/:company_id', component: CompaniesContainer },
  { path: '/companies', component: CompaniesContainer },
  
  { path: '/my-profile', component: UserProfile },
  { path: '/set-password/:token/:email', component: SetPassword },

  {
    path: '/por', component: PORContainer, routes: [
      { path: '/por/location/:location_id/project/:project_id/document/:document_id', component: PORProjectDocuments },
      { path: '/por/location/:location_id/project/:project_id/closeout/:closeout_id', component: PORProjectDocuments },
      { path: '/por/location/:location_id/project/:project_id/progress_report/:progress_report_id', component: PORProjectDocuments },
      { path: '/por/location/:location_id/project/:project_id', component: PORProjectDocuments },
      { path: '/por/location/:location_id/edit', component: LocationCRUD },
      { path: '/por/location', component: PORProjectDocuments },
      { path: '/por/project/:project_id/location/:location_id/document/:document_id', component: PORLocationDocuments },
      { path: '/por/project/:project_id/location/:location_id/closeout/:closeout_id', component: PORLocationDocuments },
      { path: '/por/project/:project_id/location/:location_id/progress_report/:progress_report_id', component: PORLocationDocuments },
      { path: '/por/project/:project_id/location/:location_id', component: PORLocationDocuments },
      // { path: "/por/:location_id", component: PORContainer },
    ],
  },  
  { path: '/forgot-password', component: ForgotPassword },
  { path: '/notifications', component: NotificationsWrapper },
  { path: '/reference-documents/document/:group_identifier', component: ReferenceDocumentsLibrary },
  { path: '/reference-documents', component: ReferenceDocumentsLibrary },
 
/** MOBILE ROUTES*/
  { path: '/dashboard', component: DashBoardWrapper },
  
  { path: '/mobile/projects-tasks/project/:project_id/:filter', component: ProjectsTasksWrapper },
  { path: '/mobile/projects-tasks/project/:project_id', component: ProjectsTasksWrapper },
  { path: '/mobile/projects-tasks/task/root/:task_id', component: TaskDetailDirectWrapper },
  { path: '/mobile/projects-tasks/task/:task_id/completion_step/:completion_step_id/photo-display/:photo_id', component: MobilePhotoDisplay },
  { path: '/mobile/projects-tasks/task/:task_id/completion_step/:completion_step_id/:action', component: TaskCompletionStepDetailWrapper },
  { path: '/mobile/projects-tasks/task/:task_id/completion_step/:completion_step_id', component: TaskCompletionStepDetailWrapper },
  { path: '/mobile/projects-tasks/task/:task_id', component: TaskDetailWrapper },
  { path: '/mobile/projects-tasks/:filter', component: ProjectsTasksWrapper },
  { path: '/mobile/projects-tasks', component: ProjectsTasksWrapper },
  
  { path: '/mobile/projects/:project_id/delays/:delay_id', component: DelayViewWrapper },
  { path: '/mobile/projects/:project_id/add-delay', component: DelayCreateWrapper, routes: [
    { path: '/mobile/projects/:project_id/add-delay/type', component: DelayTypesContainer },
    { path: '/mobile/projects/:project_id/add-delay/report', component: DelayReportContainer },
  ] },
  { path: '/mobile/projects/:project_id', component: ProjectDetailsWrapper },
  
  { path: '/mobile/projects', component: ProjectsListWrapper },
  { path: '/mobile/inventory/:task_id/edit/:inventory_item_id', component: InventoryEditWrapper },
  { path: '/mobile/inventory/:task_id', component: InventoryEditWrapper },
  { path: '/mobile/switch_company', component: SwitchCompanyWrapper },
  
  { path: '/mobile/more', component: MoreMenuWrapper },
  { path: '/mobile/settings', component: UserSettingsWrapper },
  { path: '/mobile/support', component: MobileSupportWrapper },
  
  { path: '/mobile/directory', component: DirectoryWrapper },

  { path: '/mobile/my-profile', component: UserProfileWrapper },
  { path: '/mobile/users/:user_id', component: UserProfileWrapper },

  { path: '/mobile/maps/mapMyDay', component: MapsWrapper },
  { path: '/mobile/maps', component: MapsWrapper },
  { path: '/mobilespinner', component: MobileSpinner },
  { path: '/mobile', component: MobileEntryWrapper },

  { path: '/', component: MobileEntryWrapper },
  { path: '*', component: RouteNotFound },
 // { path: "/mobile/badconnection", component: MobileBadConnectionAlert}
];

class App extends Component {
  constructor(props) {
    super(props);
    this.analytics = new Analytics();
    this.state = {
      currentLanguage: i18n.getCurrentLanguage(),
    };

    this.scrollToTop = this.scrollToTop.bind(this);
    this.handleRouteChange = this.handleRouteChange.bind(this);
    this.handleError = this.handleError.bind(this);
    this.onBackButton = this.onBackButton.bind(this);
    this.onResume = this.onResume.bind(this);
    this.onMobileAppPause = this.onMobileAppPause.bind(this);
    this.handleChangeLanguage = this.handleChangeLanguage.bind(this);

    this.history = new OurHistory(createBrowserHistory(), this.props.mobileBridge);

    // override default back button handling so our history facade is used
    document.addEventListener('backbutton', this.onBackButton, false);
    // listen for resume events, which are specific to cordova
    document.addEventListener('resume', this.onResume, false);
    
    document.addEventListener('visibilitychange', this.handleVisibilityChange);

    document.addEventListener('pause', this.onMobileAppPause, false);
  }

  onBackButton(e) {
    this.history.goBack();
  }

  handleVisibilityChange(e) {
    if (!document.hidden) {
      // User switched tab to back to AO
      CacheUtil.reloadSpaIfNeeded();
    }
  }

  onMobileAppPause() {
    ConnectivityHeartbeat.stop();
  }

  onResume(e) {
    // NOTE: android seems to call onResume after using the camera plugin
    // letting the normal onResume behavior take place can cause havoc
    // hence the following check to see if the camera plugin is in use
    // and if so bypass the normal on resume flow
    if (localStorage.takingPicture) {
      delete localStorage.takingPicture;
      return;
    }
    const lastClearDate = this.props.dataModel.storeManager.getLastClearDate();
    const interval = this.props.dataModel.storeManager.expiry;
    if (lastClearDate && ((Date.now() - lastClearDate) >= interval)) {
      this.props.dataModel.storeManager.clearState({ clearDeprecated: false });
    }
    try {
      CacheUtil.reloadSpaIfNeeded();
    } catch (error) {
      // ignore...
    }
    this.props.dataModel.handleMobileAppResume(true, this.history.parseParameters());
  }

  componentDidMount() {
    // ensure viewport zoom is disabled by default (in case app crashed while temporarily enabled)
    document.querySelector('meta[name=viewport]').setAttribute('content', 'user-scalable=no, initial-scale=1, maximum-scale=5.0, minimum-scale=1');

    window.onerror = (message, source, lineno, colno, error) => {
      this.handleError('UNCAUGHT', message, source, lineno, colno, error);
    };

    //remove hybrid loading spinner if it exists
    if (document.getElementById('loader-container')) {
      document.getElementById('loader-container').style.display = 'none';
    }

    //add change language listener
    i18n.addLanguageChangedListener(this.handleChangeLanguage);
  }

  componentWillUnmount() {
    i18n.removeLanguageChangedListener(this.handleChangeLanguage);
    document.removeEventListener('backbutton', this.onBackButton, false);
    document.removeEventListener('resume', this.onResume, false);
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    document.removeEventListener('pause', this.onMobileAppPause, false);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.navigateUri != this.props.navigateUri && this.props.navigateUri) {
      this.props.dataModel.navigateUri = null;
      this.history.push(this.props.navigateUri);
    }
  }

  handleChangeLanguage(language) {
    this.setState({ currentLanguage: language });
  } 

  handleError(type, message, source, lineno, colno, error) {
    this.props.dataModel.mobileBridge.fireNativeEvent('hybrid.debugInfo', {
      data: { info: 'App Error **********: ' + message },
    });

    const appState = this.props.dataModel.store.getState();
    const { currentUser } = appState.new_users;
    const { currentCompany } = appState.new_companies;

    const onMobile = this.props.dataModel.mobileBridge.isMobile;

    const errorInfoObject = {
      spaVersion: process.env.VERSION,
      type,
      message,
      error,
      currentUser,
      currentCompany,
      onMobile,
      source,
    };

    logErrorForCloudWatch(errorInfoObject);
  }

  scrollToTop() {
    window.scrollTo(0, 0);
  }

  handleRouteChange() {
    this.scrollToTop();
    this.logPageView();
  }

  logPageView() {
    this.analytics.setPage({ page: window.location.pathname + window.location.search });
    this.analytics.pageView(window.location.pathname);
  }

  render() {
    const { mobileBridge, needsLogin, systemPopupMessage } = this.props;
    let errorSlider = null;
    if (
      !(this.history.getCurrentLocation().pathname == '/login' || needsLogin) &&
      (this.props.infoErrorMessage != 'none' && this.props.infoErrorMessage)
    ) {
      errorSlider = <InfoErrorSlider />;
    }

    const pathName = this.history.getCurrentLocation().pathname;
    if (needsLogin && !(pathName == '/login' || pathName.includes('set-password'))) {
      dataModel.needsLogin = false;
      this.history.push('/login');
    }

    if (systemPopupMessage) {
      this.props.dataModel.showGlobalModal('SYSTEM_POPUP', {
        message: systemPopupMessage.message,
        captionText: systemPopupMessage.caption,
        height: 220,
        width: 300,
        okButtonText: 'OK',
        oneButton: true,
      });
    }
    // Apply class to push app contents down if banner is present
    let bannerHeightClass = '';
    if (!!(this.props.globalBanner && this.props.globalBanner.bannerType) && this.props.globalBanner.bannerProps) {
      if (this.props.globalBanner.bannerProps.isMobile) {
        bannerHeightClass = ' app-container--small-banner';
      }
      else {
        bannerHeightClass = ' app-container--big-banner';
      }
    }

    let timeoutPopup = null;
    if (this.props.sessionTimeout) {
      timeoutPopup = <TimeoutPopup></TimeoutPopup>;
    }
    let partialLogin = null;
    if (this.props.needsPartialLogin) {
      partialLogin = <ReloginPopup></ReloginPopup>;
    }

    // Check for iOS
    const isIos = navigator.userAgent ? /(iphone)/i.test(navigator.userAgent.toLowerCase()) : false;

    return (
      <HttpsRedirect>
        {this.props.disableAppBackground && <DisableAppBackground/>}
        {errorSlider}
        <GlobalBanner />
        <ErrorBoundary>
          <div className={'app-container' + bannerHeightClass + (isIos ? ' app-container--ios' : '')}>
            {partialLogin}
            {timeoutPopup}
            <GlobalModal />
            <CircleGlobalModal />
            <Router history={this.history}>
              <InsightsRouteGuard />
              <Switch>
              {appRoutes.map((route, i) => (
                  <MakeRoutesWithSubRoutes 
                    key={route.component.displayName ? route.component.displayName : route.component.name} 
                    {...route} 
                  />
                )
              )}
              </Switch>
            </Router>
            {!mobileBridge.isMobile &&
              <SupportForm history={this.history}/>
            }
          </div>
        </ErrorBoundary>
      </HttpsRedirect>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    dataModel: dataModel,
    needsLogin: state.main.needsLogin,
    systemPopup: state.main.systemPopup,
    infoErrorMessage: state.main.infoErrorMessage,
    systemPopupMessage: state.main.systemPopupMessage,
    navigateUri: state.main.navigateUri,
    mobileBridge: dataModel.mobileBridge,
    globalBanner: state.main.globalBanner,
    sessionTimeout: state.main.sessionTimeout,
    needsPartialLogin: state.main.needsPartialLogin,
    disableAppBackground: state.main.disableAppBackground,
    currentUser: state.new_users.currentUser,
  };
};

export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./src/App.js